module.exports = __webpack_public_path__ + "img/yoga-off-pico_thumbnail.1d96e12f.png";